import React from 'react';

import { Container } from './InputSocket.styles';

type InputSocketProps = {
  /**
   * HTML element identifier
   */
  children?: React.ReactNode;
  id?: string;
  hasError?: boolean;
};

const InputSocket = ({ id, children, hasError }: InputSocketProps) => (
  <Container
    id={id}
    borderRadius={1}
    backgroundColor="white.main"
    borderColor={hasError ? 'danger.main' : 'white.main'}
    data-testid={id}
  >
    {children}
  </Container>
);

export default InputSocket;
